module.exports = __webpack_public_path__ + "static/media/February2021Newsletter.8ce2a50d.pdf";